'use strict';

var quantity = {
	updateQuantityEvent: function () {
		var obj = {
			'event': 'update quantity'
		};
		dataLayer.push(obj);
	},

	shoppingBagMiniUpdate: function (e) {
		var obj = {
			'button_ID': e ? (e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name) : 'shopping bag mini update',
			'event': 'shoppingBagMiniUpdate'
		};
		dataLayer.push(obj);
	},

	shoppingBagMiniCheckout: function (e) {
		var obj = {
			'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name,
			'event': 'shoppingBagMiniCheckout'
		};
		dataLayer.push(obj);
	},

	removeFromBag: function (e, pid) {
		var target = $(e.target);
		var obj = {
			'event': 'removeFromBag',
			'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name
		};
		$.extend(obj, getProductsInCart(pid));
		dataLayer.push(obj);
	}
}

/**
 * Returns an object which contains product data in cart
 *
 * @returns Object
 */
function getProductsInCart(pid) {
	if ($('input[name=cartData]').length > 0) {
		var cart = JSON.parse($('input[name=cartData]').val());
		var products = cart.product;
		for (var i = 0; i < products.length; i++) {
			if (products[i].product_ID == pid) {
				// object to be pushed
				var obj = {
					'product_brand': products[i].product_brand,
					'product_category': products[i].product_category,
					'product_hierarchy': products[i].product_hierarchy,
					'product_ID': products[i].product_ID,
					'product_name': products[i].product_name,
					'product_price': products[i].product_price,
					'product_price_old': products[i].product_price_old,
					'product_quantity': products[i].product_quantity,
					'product_SKU': products[i].product_SKU,
					'product_stock_status': products[i].product_stock_status,
					'product_variant': products[i].product_variant,
					'product_vat': products[i].product_vat,
					'product_set_capacity': products[i].product_set_capacity,
					'product_set_name':  products[i].product_set_name,
					'product_set_price': products[i].product_set_price,
					'product_set_size': products[i].product_set_size,
					'product_set_SKU': products[i].product_set_size,
					'product_set_type': products[i].product_set_type,
					'voucher_ID': products[i].voucher_ID,
					'voucher_total': products[i].voucher_total
				};
			}
		}
		var productObj = {product: obj};
		return productObj;
	}
}
module.exports = quantity;
